import { useState } from 'react';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { updateEngagementData } from 'conversations-calling-message/timeline-call-metadata/common/clients/updateEngagementData';
import { getCRMObjectId, getCallType, getResult } from '../../call-message/operators/callMessageGetters';
import { logNetworkError } from 'calling-error-reporting/report/error';
import { useFetchCallSettings } from '../../call-disposition/hooks/useFetchCallSettings';
import { useFetchCallTypes } from '../hooks/useFetchCallTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const MutableCallType = ({
  callMessage,
  handleEngagementDataUpdated
}) => {
  const initialCallType = getResult(getCallType(callMessage));
  const [selectedCallType, setSelectedCallType] = useState(initialCallType);
  const {
    callTypes,
    loading
  } = useFetchCallTypes();
  const {
    callAndMeetingTypesTrackingEnabled
  } = useFetchCallSettings();
  const handleSelectType = event => {
    const option = event.target.value;
    const selectedCallTypeValue = option.value;
    const selectedCallTypeText = option.text;
    const engagementId = getCRMObjectId(callMessage);
    if (selectedCallTypeText !== selectedCallType) {
      setSelectedCallType(selectedCallTypeText);
      const payload = {
        properties: [{
          name: 'hs_activity_type',
          value: selectedCallTypeValue
        }]
      };
      updateEngagementData(engagementId, payload).then(() => {
        handleEngagementDataUpdated({
          engagementId
        });
      }).catch(networkError => {
        logNetworkError({
          error: new Error('Error updating call type'),
          networkError
        });
      });
    }
  };
  return callAndMeetingTypesTrackingEnabled ? /*#__PURE__*/_jsx(Flex, {
    paddingInlineEnd: "600",
    children: /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.call-type.label"
        })
      }),
      paddingBlockStart: "100",
      paddingBlockEnd: "400",
      children: /*#__PURE__*/_jsx(Select, {
        buttonUse: "link",
        "data-selenium-test": 'select-call-type-dropdown',
        isLoading: !callTypes && loading,
        menuWidth: "auto",
        onSelectedOptionChange: handleSelectType,
        options: callTypes || [{
          text: I18n.text('conversations-calling-message.timeline-call-metadata.call-type.placeholder'),
          value: undefined
        }],
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-calling-message.timeline-call-metadata.call-type.placeholder"
        }),
        searchable: false,
        value: selectedCallType
      })
    })
  }) : null;
};
export default MutableCallType;